import { render, staticRenderFns } from "./CadastroUsuarioExterno.vue?vue&type=template&id=1f07017e&scoped=true&"
import script from "./CadastroUsuarioExterno.vue?vue&type=script&lang=js&"
export * from "./CadastroUsuarioExterno.vue?vue&type=script&lang=js&"
import style0 from "./CadastroUsuarioExterno.vue?vue&type=style&index=0&id=1f07017e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f07017e",
  null
  
)

export default component.exports